module.exports = __webpack_public_path__ + "img/a5-s12.f191a64b.jpg";